import { render, staticRenderFns } from "./BaseAppVersion.vue?vue&type=template&id=255a8fd0&scoped=true&"
import script from "./BaseAppVersion.vue?vue&type=script&lang=js&"
export * from "./BaseAppVersion.vue?vue&type=script&lang=js&"
import style0 from "./BaseAppVersion.vue?vue&type=style&index=0&id=255a8fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a8fd0",
  null
  
)

export default component.exports